/**
 * Vite 構建的入口。
 *
 * 這個檔案承擔兩件事：
 *
 * 1. **順序**：Expo 的 web 全局量必須在任何業務 import 之前裝好。
 * 2. **分包**：i18n 必須在任何模組層級的 `t` 調用之前初始化。Rolldown 會把
 *    App 的模組圖拆成多個 chunk，被多處共享的 chunk（例如路由守衛）先於入口
 *    本體求值，而路由表這類檔案在模組層級就調用 `t`。App 靜態 import 時 i18n
 *    會留在入口本體、晚於那些 chunk；改成動態 import App，i18n 才會被放進更早
 *    求值的共享 chunk，先完成 `activate`。
 *
 * `src/index.js` 本身不動 —— 那份檔案 Metro 也要用。
 */
import '@dp-frontend/expo-vite/web-globals';
import './src/i18n';

import('./src/entry').catch((error) => {
  // 這裡是應用的最外層，啟動失敗沒有別的地方能報
  console.error('[vite-entry] 應用啟動失敗', error);
});
